import { SubHeader } from "UI_Components";
import { AlertMessage, Button, CommonModal, CoreLoader, DownloadIcon, Dropdown, Input, Label } from "common/components";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import apiManager from "networking/baseAPIManager";
import { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import { AssatSchema } from "utils/formValidationUtils";
function UpdateAssets() {
  const [uploadedImage, setUploadedImage] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showMSG, setShowMSG] = useState(false);
  const [msgType, setmsgType] = useState("info");
  const [showFileInput, setShowFileInput] = useState(false);
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const params = useParams();
  let paramsId = params.id;
  const formInitialValues = formData;
  const assetStatus = [
    { key: "unassigned", value: "unassigned" },
    { key: "repair", value: "repair" },
  ];
  const getAssetDetail = () => {
    setLoading(true);
    apiManager
      .getAsset(paramsId)
      .then((res) => {
        setUploadedImage(res?.data?.Asset?.image);
        setFormData({
          assetName: res?.data?.Asset?.assetname || "",
          purchaseDate: res?.data?.Asset?.purchase_date || "",
          manufacturer: res?.data?.Asset?.manufacturer || "",
          serialNumber: res?.data?.Asset?.serial_number || "",
          assetValue: res?.data?.Asset?.value || "",
          documentUpload: res?.data?.Asset?.image[0] || "",
          assetId: res?.data?.Asset?.assetId || "",
          purchaseFrom: res?.data?.Asset?.purchase_from || "",
          model: res?.data?.Asset?.model || "",
          supplier: res?.data?.Asset?.supplier || "",
          warranty: res?.data?.Asset?.warranty || "",
          description: res?.data?.Asset?.description || "",
          status: res?.data?.Asset?.status || "",
        });
      })
      .catch((error) => {
        console.warn(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (paramsId) getAssetDetail();
  }, [paramsId]);

  const { handleBlur, handleChange, handleSubmit, setFieldValue, values, errors, touched } = useFormik({
    enableReinitialize: true,
    initialValues: formInitialValues,
    validationSchema: AssatSchema,

    onsubmit: (values) => {},
  });

  const handleUpdateForm = () => {
    let formdata = new FormData();
    formdata.append("id", paramsId);
    formdata.append("assetname", values.assetName);
    formdata.append("assetId", values.assetId);
    formdata.append("purchase_date", values.purchaseDate);
    formdata.append("purchase_from", values.purchaseFrom);
    formdata.append("manufacturer", values.manufacturer);
    formdata.append("model", values.model);
    formdata.append("serial_number", values.serialNumber);
    formdata.append("supplier", values.supplier);
    formdata.append("warranty", values.warranty);
    formdata.append("value", values.assetValue);
    formdata.append("status", values.status);
    formdata.append("image", values.documentUpload);
    formdata.append("description", values.description);

    setLoading(true);
    apiManager
      .updateAsset(formdata)
      .then((res) => {
        setLoading(false);
        setmsgType("success");
        setShowMSG(res?.data?.message || "Asset updated successfully");
        navigate("/hrtools/assets-management/pending-asset-verification");
      })
      .catch((err) => {
        setLoading(false);
        setmsgType("error");
        setShowMSG(err?.data?.message || "failed to updated asset");
      });
  };

  const downloadAttachment = async (data) => {
    let BASE_URL = process.env.REACT_APP_BASE_URL;
    const attachmentData = `${BASE_URL}/${data}`;

    if (!attachmentData) {
      console.error("No attachment data found.");
      return;
    }

    try {
      const response = await fetch(attachmentData);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", data);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error fetching or triggering download:", error);
    }
  };
  return (
    <>
      <div>
        <SubHeader location={useLocation()} />

        <div className="col-lg-12 px-5 ">
          <AlertMessage show={showMSG} setShow={setShowMSG} type={msgType} />
          <div className="col-lg-12 pt-4 form-main ">
            <div className="gap-3 text-center subheaderbackgroundoffWhite p-2 d-flex align-items-center justify-content-center">
              <h2>Update Asset</h2>
            </div>

            <div className="container pb-5">
              <div className="form-container">
                <div className="row d-flex align-items-center justify-content-center">
                  <div className="col-md-5 mt-4 ms-2">
                    <div className=" form-outline mb-4 row align-items-center ms-0">
                      <Label label="Asset Name" required />
                      <Input
                        name="assetName"
                        value={values.assetName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.assetName}
                        touched={touched.assetName}
                      />
                    </div>
                    <div className=" form-outline mb-4 row align-items-center ms-0">
                      <Label label="Purchase Date" required />
                      <Input
                        type="date"
                        name="purchaseDate"
                        value={values.purchaseDate}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.purchaseDate}
                        touched={touched.purchaseDate}
                      />
                    </div>
                    <div className=" form-outline mb-4 row align-items-center ms-0">
                      <Label label="Manufacturer " required />
                      <Input
                        name="manufacturer"
                        value={values.manufacturer}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.manufacturer}
                        touched={touched.manufacturer}
                      />
                    </div>
                    <div className=" form-outline mb-4 row align-items-center ms-0">
                      <Label label="Serial Number" required />
                      <Input
                        name="serialNumber"
                        value={values.serialNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.serialNumber}
                        touched={touched.serialNumber}
                      />
                    </div>
                    <div className=" form-outline mb-4 row align-items-center ms-0">
                      <Label label="Asset Value" required />
                      <Input
                        name="assetValue"
                        value={values.assetValue}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.assetValue}
                        touched={touched.assetValue}
                      />
                    </div>
                    <div className=" form-outline mb-4 row align-items-center ms-0">
                      <Label label="Status" required />
                      <Dropdown
                        name="status"
                        value={values.status}
                        options={assetStatus}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={errors.status}
                        touched={touched.status}
                      />
                    </div>
                  </div>
                  <div className="col-md-5  mt-4 ms-2">
                    <div className=" form-outline mb-4 row align-items-center ms-0">
                      <Label label="Asset Id" required />
                      <Input
                        name="assetId"
                        value={values.assetId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.assetId}
                        touched={touched.assetId}
                      />
                    </div>
                    <div className=" form-outline mb-4 row align-items-center ms-0">
                      <Label label="Purchase From" required />
                      <Input
                        name="purchaseFrom"
                        value={values.purchaseFrom}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.purchaseForm}
                        touched={touched.purchaseForm}
                      />
                    </div>
                    <div className=" form-outline mb-4 row align-items-center ms-0">
                      <Label label="Model" required />
                      <Input
                        name="model"
                        value={values.model}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.model}
                        touched={touched.model}
                      />
                    </div>
                    <div className=" form-outline mb-4 row align-items-center ms-0">
                      <Label label="Supplier" required />
                      <Input
                        name="supplier"
                        value={values.supplier}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.supplier}
                        touched={touched.supplier}
                      />
                    </div>
                    <div className=" form-outline mb-4 row align-items-center ms-0">
                      <Label label="Warranty" required />
                      <Input
                        name="warranty"
                        type="date"
                        value={values.warranty}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.warranty}
                        touched={touched.warranty}
                      />
                    </div>
                    {showFileInput === false && uploadedImage.length > 0 ? (
                      <div className="form-outline w-100 d-flex gap-3 align-items-center mt-5 mb-4">
                        <Button
                          type="button"
                          label="Download"
                          onClick={() => {
                            downloadAttachment(values.documentUpload);
                          }}
                        />

                        <span
                          className="material-symbols-outlined pointer"
                          onClick={() => {
                            setShowFileInput(true);
                          }}
                        >
                          edit
                        </span>
                      </div>
                    ) : (
                      <div className=" form-outline mb-4 row align-items-center ms-0">
                        <Label label="Document Upload" required />
                        <Input
                          type="file"
                          onChange={(e) => setFieldValue("documentUpload", e.target.files[0])}
                          onBlur={handleBlur}
                          error={errors.documentUpload}
                          touched={touched.documentUpload}
                        />
                      </div>
                    )}
                  </div>
                  <div className="col-md-10 ms-2 me-2 whi">
                    <div className=" form-outline mb-4 row align-items-center ms-0">
                      <Label label="Description" required />
                      <Input
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.description}
                        touched={touched.description}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className=" col-lg-12 d-flex gap-3 justify-content-end subheaderbackground p-2 px-4">
              <Button
                className="btn btn-primary sub-btn"
                variant="primary"
                type="submit"
                label="Update"
                onClick={handleUpdateForm}
              />
              <Button
                className="btn btn-primary sub-btn"
                variant="primary"
                type="close"
                label="Close"
                onClick={() => navigate("/hrtools/assets-management/pending-asset-verification")}
              />
            </div>
          </div>
        </div>
        <CoreLoader show={loading} disableLines />
      </div>
    </>
  );
}

export default UpdateAssets;
